import { Box, BoxProps } from '@mui/material';
import { HTMLAttributes, PropsWithChildren } from 'react';
import { ContentBox } from '../base/ContentBox';

export function PageContent(
  props: PropsWithChildren<
    HTMLAttributes<HTMLDivElement> & {
      maxWidth?: BoxProps['maxWidth'];
    }
  >,
) {
  const { children, className, maxWidth } = props;

  return (
    <Box
      className={className}
      sx={{
        position: 'relative',
        paddingTop: 3,
        paddingBottom: 4,
        flexGrow: 1,
        minWidth: 0, // Allow flex item to shrink so wide content (e.g. stream waveform) stays within viewport
      }}
    >
      <ContentBox
        maxWidth={maxWidth}
        sx={{
          height: '100%',
          ml: maxWidth ? 0 : undefined,
        }}
      >
        {children}
      </ContentBox>
    </Box>
  );
}
